module.exports = __webpack_public_path__ + "assets/Crossbite.632bb0738dd335fed9c4d10d0faf8ad5.svg";